// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/chunks/" + ({"44450":"FroalaDetail","59876":"FroalaDetailLight"}[chunkId] || chunkId) + "." + {"44450":"67759f","59876":"67759f","95218":"432560"}[chunkId] + ".min.css";
};